export const contentBasePath = "https://content.tylerburke.dev";
export const linkedInUrl = "https://www.linkedin.com/in/tyler-burke/";
export const githubUrl = "https://github.com/burketyler";
export const csaaCertUrl =
  "https://www.youracclaim.com/badges/a8b5ef07-d02a-450a-959c-8ef385c9b398/public_url";
export const myEmail = "me@tylerburke.dev";

export const PAGE_CONTAINER_MAX_WIDTH = "2552px";
